<template>
    <el-card>
        <template #header>
            <content-header/>
        </template>

        <div class="header-button">
            <search-form
                ref="searchForm"
                :fields="search"
            />
            <div class="selections">
                <el-button-group>
                    <el-button
                        class="btnc"
                        size="small"
                        type="warning"
                        @click="muldialogVisible = true"
                    >批量完成
                    </el-button>
                    <el-button
                        class="btnc"
                        size="small"
                        type="success"
                        @click="mulAssignDialogVisible = true"
                    >批量指派
                    </el-button>
                </el-button-group>
                <el-button-group>
                    <el-button
                        class="btnc"
                        size="small"
                        type="primary"
                        @click="addWorkOrder"
                    >添加工单
                    </el-button>
                </el-button-group>
                <el-dialog
                    title="添加工单"
                    :visible.sync="dialogVisibleForm"
                    width="25%"
                >
                    <el-form
                        ref="form"
                        :model="form"
                        :rules="rules"
                        :errors.sync="errors"
                        :disable-redirect="true"
                        label-width="80px"
                    >
                        <el-form-item
                            required
                            prop="bike_no"
                            label="车辆编号"
                        >
                            <el-input
                                v-model="form.bike_no"
                                class="limitwidth"
                            />
                        </el-form-item>
                        <el-form-item
                            required
                            prop="type"
                            label="工单类型"
                        >
                            <el-select
                                filterable
                                clearable
                                v-model="form.type"
                                placeholder="请选择"
                                class="limitwidth"
                            >
                                <el-option
                                    v-for="item in typeForm"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            required
                            prop="reason"
                            label="原因"
                        >
                            <el-input
                                v-model="form.reason"
                                class="limitwidth"
                            />
                        </el-form-item>
                    </el-form>
                    <span
                        slot="footer"
                        class="dialog-footer"
                    >
            <el-button @click="dialogVisibleForm = false">取 消</el-button>
            <el-button
                type="primary"
                @click="onSubmit('form')"
            >确 定</el-button>
          </span>
                </el-dialog>
            </div>
        </div>

        <el-table
            ref="multipleTable"
            :data="users"
            resource="admin-users"
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="55"
                :reserve-selection="true"
                prop="id"
            />
            <el-table-column
                prop="bike_no"
                label="车牌号"
                align="center"
                show-overflow-tooltip
                min-width="100"
            />
            <!--      <el-table-column-->
            <!--        prop="box_no"-->
            <!--        label="中控号"-->
            <!--        align="center"-->
            <!--        show-overflow-tooltip-->
            <!--        min-width="120"-->
            <!--      />-->
            <!-- <el-table-column prop="trouble_part_name" label="工单类型"/> -->
            <el-table-column
                prop="type"
                label="工单类型"
                align="center"
                show-overflow-tooltip
                min-width="120"
            >
                <template slot-scope="scope">
                    <el-tag
                        v-if="scope.row.type == 3 || scope.row.type == 5 "
                        type="danger"
                        effect="plain"
                    >{{ scope.row.trouble_part_name }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.type == 1"
                        type="warning"
                    >{{ scope.row.trouble_part_name }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.type == 2"
                        type="success"
                    >{{ scope.row.trouble_part_name }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.type == 7"
                        type="info"
                    >{{ scope.row.trouble_part_name }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.type == 8 || scope.row.type == 9 ||scope.row.type == 10 ||scope.row.type == 6"
                        type="danger"
                        effect="dark"
                    >{{ scope.row.trouble_part_name }}
                    </el-tag>
                    <el-tag v-else>{{ scope.row.trouble_part_name }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="reason"
                align="center"
                show-overflow-tooltip
                min-width="100"
                label="原因"
            />
            <!-- <el-table-column label="区域地勤人员">
              <template #default="{ row }">
                <el-tag
                  v-for="i of row.workers"
                  :key="i.id"
                  class="mr-1"
                >
                  {{ i.name }}
                </el-tag>
              </template>
            </el-table-column> -->
            <el-table-column
                prop="fix_worker_name"
                label="接单人"
                align="center"
                show-overflow-tooltip
                min-width="100"
            />
            <!--      <el-table-column-->
            <!--        prop="fix_worker_phone"-->
            <!--        label="手机号"-->
            <!--        align="center"-->
            <!--        show-overflow-tooltip-->
            <!--        min-width="100"-->
            <!--      />-->
            <el-table-column
                prop="area_name"
                align="center"
                show-overflow-tooltip
                min-width="100"
                label="区域"
            />
            <el-table-column
                prop="insert_time"
                align="center"
                show-overflow-tooltip
                min-width="100"
                label="创建时间"
            />
            <!--      <el-table-column-->
            <!--        prop="times"-->
            <!--        align="center"-->
            <!--        show-overflow-tooltip-->
            <!--        min-width="80"-->
            <!--        label="插入次数"-->
            <!--      />-->
            <!-- <el-table-column prop="created_at" show-overflow-tooltip label="创建时间"/> -->
            <el-table-column
                prop="fix_start_time"
                align="center"
                show-overflow-tooltip
                min-width="100"
                label="接单时间"
            />
            <el-table-column
                prop="planned"
                label="工单进度"
                align="center"
                show-overflow-tooltip
                min-width="100"
            >
                <template slot-scope="scope">
                    <el-tag
                        v-if="scope.row.planned_status == 1"
                        type="danger"
                    >{{ scope.row.planned }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.planned_status == 2"
                        type="warning"
                    >{{ scope.row.planned }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.planned_status == 3"
                        type="success"
                    >{{ scope.row.planned }}
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.planned_status == 4"
                        type="warning"
                    >{{ scope.row.planned }}
                    </el-tag>
                    <el-tag
                        type="success"
                        v-else-if="scope.row.planned_status == 5"
                    >{{ scope.row.planned }}
                    </el-tag>
                    <el-tag
                        type="default"
                        v-else-if="scope.row.planned_status == 6"
                    >{{ scope.row.planned }}
                    </el-tag>
                    <el-tag
                        type="default"
                        v-else-if="scope.row.planned_status == 7"
                    >{{ scope.row.planned }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="fix_end_time"
                align="center"
                show-overflow-tooltip
                min-width="120"
                label="完成时间"
            />
            <el-table-column
                label="报修状态"
                align="center"
                show-overflow-tooltip
                min-width="100"
            >
                <template slot-scope="scope">
                    <el-tag
                        v-if="scope.row.fix_status"
                        type="success"
                    >已维修
                    </el-tag>
                    <el-tag
                        v-else
                        type="danger"
                    >未维修
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column
                prop="remark"
                align="center"
                show-overflow-tooltip
                min-width="120"
                label="备注"
            />

            <el-table-column
                label="操作"
                align="center"
                width="280"
                fixed="right"
            >
                <template #default="{ row }">
                    <el-button
                        size="small"
                        @click="ditailClick(row)"
                    >详情
                    </el-button>
                    <el-button
                        size="small"
                        type="warning"
                        v-if="row.is_over"
                        @click="OperationOverDialog(row)"
                    >
                        点击完成
                    </el-button>
                    <el-button
                        size="small"
                        type="success"
                        v-if="row.is_zhipai"
                        @click="OperationAssignDialog(row)"
                    >
                        点击指派
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page"/>
        </div>
        <el-dialog
            class="work-order-detail-dialog tabs-fx"
            title="工单详情"
            :visible.sync="dialogVisible"
            width="72%"
            top="4vh"
            :close-on-click-modal="false"
            @opened="onWorkOrderDetailDialogOpened"
        >
            <el-dialog
                width="520px"
                title="维修图片"
                :visible.sync="innerVisible"
                append-to-body
                custom-class="work-order-imgs-dialog"
            >
                <div class="work-order-imgs-grid">
                    <el-image
                        v-for="(src, key) in rows.fix_image"
                        :key="key"
                        :src="src"
                        :preview-src-list="rows.fix_image"
                        fit="contain"
                        class="work-order-img-thumb"
                    />
                </div>
            </el-dialog>
            <div class="work-order-detail-body">
                <div class="work-order-detail-row work-order-detail-row--top">
                    <div class="work-order-detail-col work-order-detail-col--meta-stack">
                        <div class="work-order-detail-section">
                        <div class="work-order-detail-section-title">基本信息</div>
                        <div class="work-order-detail-rows">
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">工单ID</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text work-order-detail-text--nowrap"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.id) }"
                                >{{ woLine(rows.id) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">车牌号</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.bike_no) }"
                                >{{ woLine(rows.bike_no) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">工单类型</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.trouble_part_name) }"
                                >{{ woLine(rows.trouble_part_name) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">原因</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text work-order-detail-text--multiline"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.reason) }"
                                >{{ woLine(rows.reason) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">工单级别</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text work-order-detail-text--nowrap"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.times) }"
                                >{{ woTimesLines }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">区域地勤</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text work-order-detail-text--multiline"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.area_worker) }"
                                >{{ woLine(rows.area_worker) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">维修状态</span>
                                <span class="work-order-detail-value work-order-detail-value--tags">
                                    <el-tag
                                        v-if="Number(rows.fix_status) === 1"
                                        type="success"
                                        size="small"
                                    >已维修</el-tag>
                                    <el-tag
                                        v-else
                                        type="danger"
                                        size="small"
                                    >未维修</el-tag>
                                </span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">接单时间</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.fix_start_time) }"
                                >{{ woLine(rows.fix_start_time) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">创建时间</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.insert_time) }"
                                >{{ woLine(rows.insert_time) }}</span></span>
                            </div>
                            <div
                                v-if="workOrderExtraDistanceText"
                                class="work-order-detail-row"
                            >
                                <span class="work-order-detail-label">行程距离</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text work-order-detail-text--nowrap"
                                >{{ workOrderExtraDistanceText }}</span></span>
                            </div>
                        </div>
                        </div>
                    <div
                        v-show="Number(rows.fix_status) === 1"
                        class="work-order-detail-section"
                    >
                        <div class="work-order-detail-section-title">维修信息</div>
                        <div class="work-order-detail-rows">
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">维修人员</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.fix_worker) }"
                                >{{ woLine(rows.fix_worker) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">联系电话</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.fix_worker_phone) }"
                                >{{ woLine(rows.fix_worker_phone) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">维修位置</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text work-order-detail-text--multiline"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.fix_part) }"
                                >{{ woLine(rows.fix_part) }}</span></span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">维修图片</span>
                                <span class="work-order-detail-value work-order-detail-value--tags">
                                    <el-button
                                        v-if="is_img_show"
                                        type="text"
                                        size="small"
                                        icon="el-icon-picture"
                                        @click="innerVisible = true"
                                    >查看图片</el-button>
                                    <span
                                        v-else
                                        class="work-order-detail-muted work-order-detail-text work-order-detail-text--empty"
                                    >无</span>
                                </span>
                            </div>
                            <div class="work-order-detail-row">
                                <span class="work-order-detail-label">完成时间</span>
                                <span class="work-order-detail-value"><span
                                    class="work-order-detail-text"
                                    :class="{ 'work-order-detail-text--empty': woIsEmpty(rows.fix_end_time) }"
                                >{{ woLine(rows.fix_end_time) }}</span></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="work-order-detail-col work-order-detail-col--alarms">
                    <div
                        v-if="showWorkOrderTrajectoryMap"
                        class="work-order-detail-map-cell"
                    >
                        <div class="work-order-detail-section-title work-order-detail-section-title--map">运维轨迹</div>
                        <p
                            v-if="trajectoryPath.length === 0"
                            class="trajectory-empty"
                        >暂无轨迹（运维执行工单时上报的位置）</p>
                        <div class="amap-page-container work-order-detail-amap work-order-detail-amap--row">
                            <el-amap
                                vid="workOrderDetailTrajectory"
                                :center="detailMapCenter"
                                :zoom="detailMapZoom"
                                :amap-manager="detailAmapManager"
                                :plugin="detailMapPlugin"
                                class="work-order-detail-amap-inner work-order-detail-amap-inner--row"
                            >
                                <el-amap-polyline
                                    v-if="trajectoryPath.length >= 2"
                                    :path="trajectoryPath"
                                    :stroke-color="'#1890ff'"
                                    :stroke-weight="10"
                                    :stroke-opacity="1"
                                    line-join="round"
                                    :events="trajectoryOrderLikePolylineEvents"
                                />
                                <el-amap-marker
                                    v-for="(pt, tidx) in trajectoryPointsDetail"
                                    :key="'wo-gj-' + tidx"
                                    :position="pt.position"
                                    :offset="tidx === 0 || tidx === trajectoryPointsDetail.length - 1 ? [-13, -13] : [-4, -4]"
                                    :events="workTrajectoryMarkerEvents(pt, tidx, trajectoryPointsDetail.length)"
                                >
                                    <div
                                        v-if="tidx === 0"
                                        class="work-order-detail-traj-pin work-order-detail-traj-pin--start"
                                    >起</div>
                                    <div
                                        v-else-if="tidx === trajectoryPointsDetail.length - 1"
                                        class="work-order-detail-traj-pin work-order-detail-traj-pin--end"
                                    >终</div>
                                    <div
                                        v-else
                                        class="work-order-detail-traj-dot"
                                        :class="{ 'work-order-detail-traj-dot--active': workTrajectoryHoverIndex === tidx }"
                                    />
                                </el-amap-marker>
                                <el-amap-info-window
                                    v-if="workOrderTrajInfoWindow.visible"
                                    :position="workOrderTrajInfoWindow.position"
                                    :visible="workOrderTrajInfoWindow.visible"
                                    :content="workOrderTrajInfoWindow.content"
                                    :is-custom="true"
                                    :offset="[0, -18]"
                                    :show-shadow="false"
                                />
                            </el-amap>
                        </div>
                    </div>
                    <div
                        v-if="showWorkOrderTrajectoryMap"
                        class="work-order-detail-map-cell"
                    >
                        <div class="work-order-detail-section-title work-order-detail-section-title--map">时间段轨迹</div>
                        <p class="trajectory-empty trajectory-hint">根据<strong>接单—完成</strong>时间查询车辆定位（未完成则截止到当前）。</p>
                        <p
                            v-if="periodTrajectoryLoading"
                            class="trajectory-empty"
                        >正在加载车辆轨迹…</p>
                        <p
                            v-else-if="periodTrajectoryPath.length === 0"
                            class="trajectory-empty"
                        >该时间段暂无车辆轨迹数据</p>
                        <div class="amap-page-container work-order-detail-amap work-order-detail-amap--row">
                            <el-amap
                                vid="workOrderPeriodTrajectory"
                                :center="periodMapCenter"
                                :zoom="periodMapZoom"
                                :amap-manager="periodAmapManager"
                                :plugin="detailMapPlugin"
                                class="work-order-detail-amap-inner work-order-detail-amap-inner--row"
                            >
                                <el-amap-polyline
                                    v-if="periodTrajectoryPath.length >= 2"
                                    :path="periodTrajectoryPath"
                                    :stroke-color="'#1890ff'"
                                    :stroke-weight="10"
                                    :stroke-opacity="1"
                                    line-join="round"
                                    :events="trajectoryOrderLikePolylineEvents"
                                />
                                <el-amap-marker
                                    v-for="(pt, pidx) in periodTrajectoryPointsDetail"
                                    :key="'wo-pd-' + pidx"
                                    :position="pt.position"
                                    :offset="pidx === 0 || pidx === periodTrajectoryPointsDetail.length - 1 ? [-13, -13] : [-4, -4]"
                                    :events="periodTrajectoryMarkerEvents(pt, pidx, periodTrajectoryPointsDetail.length)"
                                >
                                    <div
                                        v-if="pidx === 0"
                                        class="work-order-detail-traj-pin work-order-detail-traj-pin--start"
                                    >起</div>
                                    <div
                                        v-else-if="pidx === periodTrajectoryPointsDetail.length - 1"
                                        class="work-order-detail-traj-pin work-order-detail-traj-pin--end"
                                    >终</div>
                                    <div
                                        v-else
                                        class="work-order-detail-traj-dot"
                                        :class="{ 'work-order-detail-traj-dot--active': periodTrajectoryHoverIndex === pidx }"
                                    />
                                </el-amap-marker>
                                <el-amap-info-window
                                    v-if="periodTrajInfoWindow.visible"
                                    :position="periodTrajInfoWindow.position"
                                    :visible="periodTrajInfoWindow.visible"
                                    :content="periodTrajInfoWindow.content"
                                    :is-custom="true"
                                    :offset="[0, -18]"
                                    :show-shadow="false"
                                />
                            </el-amap>
                        </div>
                    </div>
                    <div class="work-order-detail-section work-order-detail-section--flush">
                        <el-tabs
                            v-model="activeName"
                            class="work-order-detail-tabs"
                            @tab-click="handleClick"
                        >
                            <el-tab-pane
                                label="限制警报类型"
                                name="first"
                            />
                            <el-tab-pane
                                label="不限警报类型"
                                name="second"
                            />
                        </el-tabs>
                        <div class="work-order-warning-table-wrap">
                            <el-table
                                :data="warningLogs"
                                stripe
                                size="small"
                                class="work-order-warning-table"
                                empty-text="暂无告警记录"
                                style="width: 100%"
                            >
                                <el-table-column
                                    prop="created_at"
                                    label="时间"
                                    align="center"
                                    min-width="156"
                                />
                                <el-table-column
                                    prop="type_name"
                                    label="报警类型"
                                    align="center"
                                    min-width="120"
                                    show-overflow-tooltip
                                />
                                <el-table-column
                                    prop="source"
                                    label="来源"
                                    align="center"
                                    min-width="88"
                                    show-overflow-tooltip
                                />
                                <el-table-column
                                    label="日志"
                                    align="center"
                                    width="72"
                                >
                                    <template slot-scope="scope">
                                        <el-popover
                                            trigger="click"
                                            placement="left"
                                            width="360"
                                        >
                                            <pre class="work-order-log-pre">{{ scope.row.body }}</pre>
                                            <el-button
                                                slot="reference"
                                                type="text"
                                                size="small"
                                            >查看</el-button>
                                        </el-popover>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    @click="dialogVisible = false"
                >关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 批量完成 -->
        <el-dialog
            title="批量操作完成"
            :visible.sync="muldialogVisible"
            width="30%"
        >
            <span>确定批量设为已完成吗？</span>
            <span
                slot="footer"
                class="dialog-footer"
            >
        <el-button @click="muldialogVisible = false">取 消</el-button>
        <el-button
            type="primary"
            @click="mulOperation"
        >确 定</el-button>
      </span>
        </el-dialog>

        <!-- 单个完成 -->
        <el-dialog
            title="操作完成"
            :visible.sync="dialogOverVisible"
            width="30%"
        >
            <span>确定设为已完成吗？</span>
            <span
                slot="footer"
                class="dialog-footer"
            >
        <el-button @click="dialogOverVisible = false">取 消</el-button>
        <el-button
            type="primary"
            @click="OperationOver"
        >确 定</el-button>
      </span>
        </el-dialog>

        <!-- 批量指派 -->
        <el-dialog
            title="批量操作指派"
            :visible.sync="mulAssignDialogVisible"
            width="30%"
        >
            <el-form>
                <el-form-item
                    required
                    label="指派地勤人员:"
                >
                    <el-select
                        v-model="worker_id"
                        placeholder="请选择人员"
                        class="widm"
                    >
                        <el-option
                            v-for="item in usersOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
            </el-form>
            <span
                slot="footer"
                class="dialog-footer"
            >
        <el-button @click="mulAssignDialogVisible = false">取 消</el-button>
        <el-button
            type="primary"
            @click="mulOperationAssign"
        >确 定</el-button>
      </span>
        </el-dialog>

        <!-- 单个指派 -->
        <el-dialog
            title="指派"
            :visible.sync="AssignDialogVisible"
            width="30%"
        >
            <div class="info-wrp">
                <div class="title">故障信息</div>
                <div class="info-item">
                    <span>车牌号：</span> <span>{{ rows.bike_no }}</span>
                </div>
                <div class="info-item">
                    <span>工单类型：</span> <span>{{ rows.trouble_part_name }}</span>
                </div>
                <div class="info-item">
                    <span>原因：</span> <span>{{ rows.reason }}</span>
                </div>
            </div>
            <el-form>
                <el-form-item
                    label-width="124px"
                    required
                    label="指派地勤人员:"
                >
                    <el-select
                        v-model="worker_id"
                        placeholder="请选择人员"
                        class="widm"
                    >
                        <el-option
                            v-for="item in usersOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
            </el-form>
            <span
                slot="footer"
                class="dialog-footer"
            >
        <el-button @click="AssignDialogVisible = false">取 消</el-button>
        <el-button
            type="primary"
            @click="OperationAssign"
        >确 定</el-button>
      </span>
        </el-dialog>
    </el-card>
</template>

<script>
import LzForm from "@c/LzForm";
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import {
    getWorkOrders,
    getworkOrderTypes,
    addworkOrder,
    mulOverWorkOrder,
    mulAssignWorkOrder,
    getWarningByWorkOrderId,
    getWorkOrderDetail,
    getBikeTimeTrajectory
} from "@/api/work-order";
import VueAMap from "vue-amap";
import {getAreas} from "@/api/area";
import {getWorkers} from "@/api/workers";
import {mixinsAutoPageSize} from "@/libs/utils";
import {getAdminUsersMerchant} from "@/api/admin-merchant";
import env from "../../env";

export default {
    name: "Index",
    components: {
        LzForm,
        SearchForm,
        Pagination
    },
    data() {
        const detailAmapManager = new VueAMap.AMapManager();
        const periodAmapManager = new VueAMap.AMapManager();
        return {
            detailAmapManager,
            periodAmapManager,
            periodMapCenter: [121.59996, 31.197646],
            periodMapZoom: 13,
            periodTrajectoryPath: [],
            periodTrajectoryPointsDetail: [],
            periodTrajectoryLoading: false,
            workOrderTrajInfoWindow: {
                visible: false,
                position: [121.59996, 31.197646],
                content: ""
            },
            periodTrajInfoWindow: {
                visible: false,
                position: [121.59996, 31.197646],
                content: ""
            },
            /** 蓝线、路径方向箭头（线宽见模板 stroke-weight） */
            trajectoryOrderLikePolylineEvents: {
                init(instance) {
                    if (instance && typeof instance.setOptions === "function") {
                        instance.setOptions({
                            showDir: true,
                            lineJoin: "round"
                        });
                    }
                }
            },
            workTrajectoryHoverIndex: null,
            periodTrajectoryHoverIndex: null,
            detailMapCenter: [121.59996, 31.197646],
            detailMapZoom: 13,
            detailMapPlugin: [
                {pName: "Scale", position: "RB"},
                {pName: "ToolBar"}
            ],
            trajectoryPath: [],
            trajectoryPointsDetail: [],
            search: [
                {
                    type: "el-select",
                    field: "area_id",
                    label: "骑行区域",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        }
                    ]
                },
                {
                    type: "el-select",
                    field: "type",
                    label: "工单类型",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        }
                    ]
                },
                {
                    type: "el-select",
                    field: "status",
                    label: "工单状态",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        },
                        {
                            id: "0",
                            name: "未维修"
                        },
                        {
                            id: "1",
                            name: "已维修"
                        }
                    ]
                },
                {
                    type: "time-between",
                    field: "time_between",
                    label1: "接单时间-开始",
                    label2: "接单时间-结束"
                },
                {
                    tpye: "super-input",
                    label: "车牌号",
                    field: "bike_no"
                },
                {
                    tpye: "super-input",
                    label: "运维人员",
                    field: "worker_name_or_phone"
                },
                {
                    tpye: "super-input",
                    label: "备注",
                    field: "remark"
                },
                {
                    type: "el-select",
                    field: "planned",
                    label: "工单进度",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        },
                        {
                            id: "1",
                            name: "待接单"
                        },
                        {
                            id: "2",
                            name: "处理中"
                        },
                        {
                            id: "3",
                            name: "已处理"
                        }, {
                            id: "4",
                            name: "待审核"
                        }, {
                            id: "5",
                            name: "已完成"
                        },
                        {
                            id: "6",
                            name: "未完成"
                        },
                        {
                            id: "7",
                            name: "重复工单"
                        }
                    ]
                }
            ],
            multipleSelection: [],
            muldialogVisible: false,
            dialogOverVisible: false,
            mulAssignDialogVisible: false,
            AssignDialogVisible: false,
            assign_work_order_id: "",
            over_work_order_id: "",
            worker_id: "",
            usersOptions: [],
            users: [],
            warningLogs: [],
            page: null,
            first_blood: true,
            dialogVisible: false,
            innerVisible: false,
            typeForm: [],
            activeName: "first",
            rows: {
                id: null,
                fix_status: "",
                bike_no: "",
                type: null,
                trouble_part_name: "",
                area_worker: "",
                fix_start_time: "",
                fix_worker: "",
                fix_worker_phone: "",
                fix_part: "",
                reason: "",
                fix_image: [],
                fix_end_time: "",
                insert_time: "", // 报警时间
                tiems: 1,
                extra: null
            },
            is_img_show: false,
            dialogVisibleForm: false,
            form: {
                bike_no: "",
                reason: "",
                type: ""
            },
            errors: {},
            rules: {
                bike_no: [
                    {required: true, message: "请输入车辆编号", trigger: "blur"}
                ],
                reason: [{required: true, message: "请输入原因", trigger: "blur"}],
                type: [{required: true, message: "请选择类型", trigger: "blur"}]
            }
        };
    },
    inject: ["reload"],
    mixins: [mixinsAutoPageSize],

    computed: {
        showWorkOrderTrajectoryMap() {
            const t = this.rows.type;
            return t === 0 || t === 16;
        },
        woTimesLines() {
            const t = this.rows.times;
            if (t == null || t === "") {
                return "—";
            }
            return `${t}（数值越大越紧急）`;
        },
        workOrderExtraDistanceText() {
            const ex = this.rows.extra;
            if (!ex || typeof ex !== "object" || Array.isArray(ex)) {
                return null;
            }
            if (!Object.prototype.hasOwnProperty.call(ex, "distance")) {
                return null;
            }
            const d = ex.distance;
            if (d == null || d === "") {
                return null;
            }
            const n = Number(d);
            if (!Number.isFinite(n) || n < 0) {
                return null;
            }
            if (n >= 1000) {
                return `${(n / 1000).toFixed(2)} 公里`;
            }
            if (n !== Math.round(n)) {
                return `${n.toFixed(2)} 米`;
            }
            return `${Math.round(n)} 米`;
        }
    },

    watch: {
        $route: {
            async handler(newVal) {
                await this.autoPageSize(55, newVal);
                const {
                    data: {data, meta}
                } = await getWorkOrders(newVal.query);
                this.users = data;
                this.page = meta;
            },
            immediate: true
        }
    },
    async created() {
        const [{data: areas}, {data: bike_trouble_parts}] = await Promise.all([
            getAreas({all: 1}),
            getworkOrderTypes()
        ]);

        this.search[0].options.push.apply(this.search[0].options, areas);
        this.search[1].options.push.apply(
            this.search[1].options,
            bike_trouble_parts
        );
        this.typeForm = bike_trouble_parts;
        const [{data: workers}] = await Promise.all([getWorkers({all: 1})]);
        this.usersOptions = [];
        workers.map(e => {
            this.usersOptions.push({value: e.id, label: e.name});
        });
        if (this.$store.state.users.user.roles[0] === "administrator") {
            const [{data: merchant}] = await Promise.all([
                getAdminUsersMerchant({all: 1})
            ]);
            if (env.isPosSwitch == true) {
                this.search.push({
                    type: "el-select",
                    field: "merchant_id",
                    label: "商户",
                    options: [
                        {
                            id: "",
                            name: "全部"
                        }
                    ]
                });
                this.search[5].options.push.apply(
                    this.search[5].options,
                    merchant.data
                );
            }
        }
    },
    methods: {
        handleSelectionChange(val) {
            // 多选改变时触发
            this.multipleSelection = val.map(i => i.id);
            // console.log(this.multipleSelection)
        },
        woIsEmpty(v) {
            if (v == null || v === "") {
                return true;
            }
            if (typeof v === "string" && v.trim() === "") {
                return true;
            }
            return false;
        },
        woLine(v) {
            if (this.woIsEmpty(v)) {
                return "—";
            }
            return String(v);
        },
        mulOperation() {
            mulOverWorkOrder({ids: this.multipleSelection}).then(res => {
                res.then(data => {
                    this.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    this.dialogVisibleForm = false;
                    this.reload();
                });
            });
            this.muldialogVisible = false;
        },
        OperationOverDialog(row) {
            // 单个完成
            this.dialogOverVisible = true;
            this.over_work_order_id = row.id;
        },
        OperationOver() {
            mulOverWorkOrder({ids: [this.over_work_order_id]}).then(res => {
                res.then(data => {
                    this.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    this.dialogOverVisible = false;
                    this.reload();
                });
            });
            this.dialogOverVisible = false;
        },
        OperationAssignDialog(row) {
            // 单个指派弹框
            this.AssignDialogVisible = true;
            this.rows.bike_no = row.bike_no;
            this.rows.trouble_part_name = row.trouble_part_name; // 报修部分
            this.rows.reason = row.reason;
            this.assign_work_order_id = row.id;
        },
        OperationAssign() {
            // 单个指派操作
            mulAssignWorkOrder({
                ids: [this.assign_work_order_id],
                worker_id: this.worker_id
            }).then(res => {
                res.then(data => {
                    this.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    this.AssignDialogVisible = false;
                    this.reload();
                });
            });
            this.AssignDialogVisible = false;
        },
        mulOperationAssign() {
            // 批量指派操作
            mulAssignWorkOrder({
                ids: this.multipleSelection,
                worker_id: this.worker_id
            }).then(res => {
                res.then(data => {
                    this.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    this.mulAssignDialogVisible = false;
                    this.reload();
                });
            });
            this.mulAssignDialogVisible = false;
        },
        trajectoryHoverLikeOrder(pt, idx, totalLen) {
            const role =
                pt.role != null && pt.role !== "" ? String(pt.role) : "—";
            const time = pt.boxTime || "—";
            const text = `点:${idx}/${totalLen},时间:${time},角色:${role}`;
            return `<div class="wo-order-traj-tip">${text}</div>`;
        },
        workTrajectoryMarkerEvents(pt, idx, totalLen) {
            return {
                mouseover: () => {
                    this.workTrajectoryHoverIndex = idx;
                    this.workOrderTrajInfoWindow.visible = true;
                    this.workOrderTrajInfoWindow.position = [
                        pt.position[0],
                        pt.position[1]
                    ];
                    this.workOrderTrajInfoWindow.content = this.trajectoryHoverLikeOrder(
                        pt,
                        idx,
                        totalLen
                    );
                },
                mouseout: () => {
                    this.workTrajectoryHoverIndex = null;
                    this.workOrderTrajInfoWindow.visible = false;
                }
            };
        },
        periodTrajectoryMarkerEvents(pt, idx, totalLen) {
            return {
                mouseover: () => {
                    this.periodTrajectoryHoverIndex = idx;
                    this.periodTrajInfoWindow.visible = true;
                    this.periodTrajInfoWindow.position = [
                        pt.position[0],
                        pt.position[1]
                    ];
                    this.periodTrajInfoWindow.content = this.trajectoryHoverLikeOrder(
                        pt,
                        idx,
                        totalLen
                    );
                },
                mouseout: () => {
                    this.periodTrajectoryHoverIndex = null;
                    this.periodTrajInfoWindow.visible = false;
                }
            };
        },
        parseFixImages(raw) {
            if (raw == null || raw === "") {
                return [];
            }
            if (Array.isArray(raw)) {
                return raw.filter(Boolean);
            }
            if (typeof raw === "object") {
                return [];
            }
            try {
                const v = JSON.parse(raw);
                if (Array.isArray(v)) {
                    return v.filter(Boolean);
                }
                if (v) {
                    return [String(v)];
                }
            } catch (e) {
                if (typeof raw === "string" && raw) {
                    return [raw];
                }
            }
            return [];
        },
        applyWorkOrderGuiji(guiji) {
            this.trajectoryPointsDetail = [];
            const raw = guiji || [];
            const points = [];
            raw.forEach((p, i) => {
                const lng = Number(p.longitude);
                const lat = Number(p.latitude);
                if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
                    return;
                }
                points.push({
                    position: [lng, lat],
                    index: i + 1,
                    boxTime: p.box_time || p.boxTime || "",
                    role: p.type != null && p.type !== "" ? p.type : ""
                });
            });
            this.trajectoryPath = points.map(x => x.position);
            this.trajectoryPointsDetail = points;
            this.syncDetailMapCenterFromTrajectory();
        },
        syncDetailMapCenterFromTrajectory() {
            const path = this.trajectoryPath;
            if (!path.length) {
                this.detailMapCenter = [121.59996, 31.197646];
                this.detailMapZoom = 13;
                return;
            }
            if (path.length === 1) {
                this.detailMapCenter = [path[0][0], path[0][1]];
                this.detailMapZoom = 16;
                return;
            }
            const lngs = path.map(p => p[0]);
            const lats = path.map(p => p[1]);
            this.detailMapCenter = [
                (Math.min(...lngs) + Math.max(...lngs)) / 2,
                (Math.min(...lats) + Math.max(...lats)) / 2
            ];
            const span = Math.max(
                Math.max(...lngs) - Math.min(...lngs),
                Math.max(...lats) - Math.min(...lats)
            );
            this.detailMapZoom = span < 0.008 ? 16 : span < 0.03 ? 14 : 12;
        },
        onWorkOrderDetailDialogOpened() {
            this.$nextTick(() => {
                this.fitWorkOrderDetailMap();
                this.fitPeriodWorkOrderMap();
            });
        },
        fitWorkOrderDetailMap() {
            const map =
                this.detailAmapManager.getMap &&
                this.detailAmapManager.getMap();
            if (!map) {
                return;
            }
            if (typeof map.resize === "function") {
                map.resize();
            }
            const AMap = window.AMap;
            if (!AMap || !this.trajectoryPath.length) {
                return;
            }
            if (this.trajectoryPath.length === 1) {
                map.setCenter(this.trajectoryPath[0]);
                map.setZoom(this.detailMapZoom);
                return;
            }
            const b = new AMap.Bounds(
                this.trajectoryPath[0],
                this.trajectoryPath[0]
            );
            this.trajectoryPath.forEach(p => {
                b.extend(new AMap.LngLat(p[0], p[1]));
            });
            map.setBounds(b, false, [40, 40, 40, 40]);
        },
        syncPeriodMapCenterFromTrajectory() {
            const path = this.periodTrajectoryPath;
            if (!path.length) {
                this.periodMapCenter = [121.59996, 31.197646];
                this.periodMapZoom = 13;
                return;
            }
            if (path.length === 1) {
                this.periodMapCenter = [path[0][0], path[0][1]];
                this.periodMapZoom = 16;
                return;
            }
            const lngs = path.map(p => p[0]);
            const lats = path.map(p => p[1]);
            this.periodMapCenter = [
                (Math.min(...lngs) + Math.max(...lngs)) / 2,
                (Math.min(...lats) + Math.max(...lats)) / 2
            ];
            const span = Math.max(
                Math.max(...lngs) - Math.min(...lngs),
                Math.max(...lats) - Math.min(...lats)
            );
            this.periodMapZoom = span < 0.008 ? 16 : span < 0.03 ? 14 : 12;
        },
        fitPeriodWorkOrderMap() {
            const map =
                this.periodAmapManager.getMap &&
                this.periodAmapManager.getMap();
            if (!map) {
                return;
            }
            if (typeof map.resize === "function") {
                map.resize();
            }
            const AMap = window.AMap;
            if (!AMap || !this.periodTrajectoryPath.length) {
                return;
            }
            if (this.periodTrajectoryPath.length === 1) {
                map.setCenter(this.periodTrajectoryPath[0]);
                map.setZoom(this.periodMapZoom);
                return;
            }
            const b = new AMap.Bounds(
                this.periodTrajectoryPath[0],
                this.periodTrajectoryPath[0]
            );
            this.periodTrajectoryPath.forEach(p => {
                b.extend(new AMap.LngLat(p[0], p[1]));
            });
            map.setBounds(b, false, [40, 40, 40, 40]);
        },
        formatNowDatetime() {
            const n = new Date();
            const p = x => String(x).padStart(2, "0");
            return `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())} ${p(n.getHours())}:${p(n.getMinutes())}:${p(n.getSeconds())}`;
        },
        addOneHourDatetime(isoLike) {
            const t = Date.parse(String(isoLike).replace(/-/g, "/"));
            if (!Number.isFinite(t)) {
                return null;
            }
            const d = new Date(t + 60 * 60 * 1000);
            const p = x => String(x).padStart(2, "0");
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
        },
        async fetchWorkOrderPeriodTrajectory() {
            this.periodTrajectoryPath = [];
            this.periodTrajectoryPointsDetail = [];
            this.syncPeriodMapCenterFromTrajectory();
            if (!this.showWorkOrderTrajectoryMap) {
                return;
            }
            const bikeNo = this.rows.bike_no;
            let tStart = this.rows.fix_start_time;
            if (this.woIsEmpty(tStart)) {
                tStart = this.rows.insert_time;
            }
            if (this.woIsEmpty(bikeNo) || this.woIsEmpty(tStart)) {
                return;
            }
            let tEnd = this.rows.fix_end_time;
            if (this.woIsEmpty(tEnd)) {
                tEnd = this.formatNowDatetime();
            }
            const startMs = Date.parse(String(tStart).replace(/-/g, "/"));
            const endMs = Date.parse(String(tEnd).replace(/-/g, "/"));
            if (Number.isFinite(startMs) && Number.isFinite(endMs) && endMs <= startMs) {
                const bumped = this.addOneHourDatetime(tStart);
                if (bumped) {
                    tEnd = bumped;
                }
            }
            this.periodTrajectoryLoading = true;
            try {
                const res = await getBikeTimeTrajectory({
                    bike_no: bikeNo,
                    time_between: [tStart, tEnd]
                });
                const raw = res.data;
                const body = Array.isArray(raw) ? {} : raw || {};
                const locs = body.locations || [];
                const times = body.locations_time || [];
                const roles = body.locations_role || [];
                this.periodTrajectoryPath = locs
                    .map(p => [Number(p[0]), Number(p[1])])
                    .filter(
                        x => Number.isFinite(x[0]) && Number.isFinite(x[1])
                    );
                this.periodTrajectoryPointsDetail = this.periodTrajectoryPath.map(
                    (position, i) => ({
                        position,
                        index: i + 1,
                        boxTime: times[i] || "",
                        role:
                            roles[i] != null && roles[i] !== ""
                                ? roles[i]
                                : ""
                    })
                );
                this.syncPeriodMapCenterFromTrajectory();
            } catch (e) {
                this.periodTrajectoryPath = [];
                this.periodTrajectoryPointsDetail = [];
                this.syncPeriodMapCenterFromTrajectory();
            } finally {
                this.periodTrajectoryLoading = false;
                this.$nextTick(() => this.fitPeriodWorkOrderMap());
            }
        },
        async ditailClick(row) {
            // 详情
            this.activeName = "first";
            this.trajectoryPath = [];
            this.trajectoryPointsDetail = [];
            this.periodTrajectoryPath = [];
            this.periodTrajectoryPointsDetail = [];
            this.workOrderTrajInfoWindow.visible = false;
            this.periodTrajInfoWindow.visible = false;
            this.workTrajectoryHoverIndex = null;
            this.periodTrajectoryHoverIndex = null;
            this.syncDetailMapCenterFromTrajectory();
            this.syncPeriodMapCenterFromTrajectory();

            this.rows.fix_status = row.fix_status;
            this.rows.bike_no = row.bike_no;
            this.rows.type = row.type;
            this.rows.trouble_part_name = row.trouble_part_name; // 报修部分
            this.rows.fix_start_time = row.fix_start_time;
            this.rows.area_worker = "";
            this.rows.area_worker = (row.workers || [])
                .map(i => i.name)
                .filter(Boolean)
                .join("、");
            this.rows.fix_worker = row.fix_over_worker_name;
            this.rows.reason = row.reason;
            this.rows.fix_worker_phone = row.fix_over_worker_phone;
            this.rows.times = row.times;
            this.rows.id = row.id;
            this.rows.fix_part = row.fix_part;
            this.rows.fix_image = this.parseFixImages(row.fix_img);
            this.is_img_show = this.rows.fix_image.length > 0;
            this.rows.fix_end_time = row.fix_end_time;
            this.rows.insert_time = row.insert_time;
            this.rows.extra = null;
            this.dialogVisible = true;
            const [warningRes] = await Promise.all([
                getWarningByWorkOrderId({id: row.id})
            ]);
            const wBody = warningRes.data;
            this.warningLogs = Array.isArray(wBody)
                ? wBody
                : (wBody && wBody.data) || [];
            try {
                const detailRes = await getWorkOrderDetail({
                    work_order_id: row.id
                });
                const detail = detailRes.data || {};
                this.rows.extra = detail.extra || null;
                this.applyWorkOrderGuiji(detail.guiji);
            } catch (e) {
                this.rows.extra = null;
                this.applyWorkOrderGuiji([]);
            }
            await this.fetchWorkOrderPeriodTrajectory();
            this.$nextTick(() => {
                this.fitWorkOrderDetailMap();
                this.fitPeriodWorkOrderMap();
            });
        },
        async handleClick(tab, event) {
            const params = {id: this.rows.id};
            if (tab.name === "second") {
                params.is_limit_type = 0;
            }
            const warningRes = await getWarningByWorkOrderId(params);
            const wBody = warningRes.data;
            this.warningLogs = Array.isArray(wBody)
                ? wBody
                : (wBody && wBody.data) || [];
        },
        addWorkOrder() {
            this.dialogVisibleForm = true;
        },
        onSubmit(formName) {
            console.log(11);
            this.$refs[formName].validate(valid => {
                if (valid) {
                    addworkOrder(this.form).then(res => {
                        res.then(data => {
                            this.$message({
                                message: "添加成功",
                                type: "success"
                            });
                            this.dialogVisibleForm = false;
                            this.reload();
                        });
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.header-button {
    display: flex;
    justify-content: space-between;

    .selections {
        display: inline-block;
        margin-right: 10px;
        width: 20%;

        .btnc {
            margin-bottom: 10px;
        }
    }
}

.limitwidth {
    width: 80%;
    margin-right: 10px;
}

.info-wrp {
    margin-top: -50px;
}

.info-wrp .title {
    font-size: 16px;
    margin: 40px 0 10px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
}

.info-wrp .info-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 10px;
}

.info-wrp .info-item > span:first-child {
    display: inline-block;
    width: 120px;
    text-align: right;
}

.info-wrp .pic-wrp > div:first-child {
    width: 120px;
    text-align: right;
}

.widm {
    width: 200px;
}

/* 工单详情弹窗 */
.work-order-detail-body {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    margin-top: -12px;
}

.work-order-detail-row--top {
    display: flex;
    align-items: stretch;
    gap: 20px;
    flex-wrap: nowrap;
    min-width: 0;
}

.work-order-detail-row--maps {
    display: flex;
    align-items: stretch;
    gap: 20px;
    flex-wrap: nowrap;
    min-width: 0;
}

.work-order-detail-row--top .work-order-detail-section {
    margin-bottom: 0;
}

.work-order-detail-col {
    min-width: 0;
}

.work-order-detail-col--meta-stack {
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 0.85 1 0;
    min-width: 0;
}

.work-order-detail-col--alarms {
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 2.5 1 0;
    min-width: 0;
}

.work-order-detail-col--alarms > .work-order-detail-section,
.work-order-detail-col--alarms > .work-order-detail-map-cell {
    margin-bottom: 0;
}

.work-order-detail-section {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 14px 16px 16px;
    margin-bottom: 14px;
}

.work-order-detail-section--flush {
    padding-bottom: 8px;
}

.work-order-detail-section-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 12px;
    padding-left: 10px;
    border-left: 3px solid #409eff;
    line-height: 1.3;
}

.work-order-detail-section-title--map {
    margin-bottom: 8px;
}

.work-order-detail-rows {
    display: grid;
    grid-template-columns: 88px minmax(0, 1fr);
    column-gap: 12px;
    row-gap: 10px;
    align-items: start;
}

/* 仅作用于基本信息/维修信息里的键值行；勿用于 --top / --maps 外层行，否则会 display:contents 盖掉 flex */
.work-order-detail-rows .work-order-detail-row {
    display: contents;
    font-size: 13px;
    line-height: 1.5;
}

.work-order-detail-label {
    margin: 0;
    padding: 0;
    color: #909399;
    text-align: right;
    line-height: 1.5;
}

.work-order-detail-value {
    margin: 0;
    padding: 0;
    min-width: 0;
    color: #303133;
    line-height: 1.5;
    word-break: break-word;
    overflow-wrap: break-word;
}

.work-order-detail-text {
    display: inline;
}

.work-order-detail-text--multiline {
    display: block;
    white-space: normal;
    word-break: break-word;
}

.work-order-detail-text--empty,
.work-order-detail-text--nowrap {
    white-space: nowrap;
}

.work-order-detail-text--multiline.work-order-detail-text--empty {
    white-space: nowrap;
    word-break: normal;
}

.work-order-detail-value--tags {
    line-height: 1.5;
}

.work-order-detail-muted {
    color: #c0c4cc;
}

.work-order-warning-table-wrap {
    max-height: 320px;
    overflow: auto;
    border-radius: 0 0 6px 6px;
}

.work-order-warning-table {
    border-radius: 4px;
}

.work-order-log-pre {
    margin: 0;
    padding: 8px;
    max-width: 100%;
    max-height: 240px;
    overflow: auto;
    font-size: 12px;
    line-height: 1.45;
    white-space: pre-wrap;
    word-break: break-word;
    background: #f5f7fa;
    border-radius: 4px;
}

.work-order-detail-map-cell {
    flex: 1 1 0;
    min-width: 0;
    padding: 12px 14px 14px;
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
}

.work-order-detail-map-cell .trajectory-hint {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}

.trajectory-empty {
    color: #909399;
    font-size: 13px;
    margin: 0 0 10px;
    line-height: 1.5;
}

.work-order-detail-amap {
    width: 100%;
    margin-top: 4px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #e4e7ed;
    height: clamp(400px, 48vh, 620px);
}

.work-order-detail-amap-inner {
    width: 100%;
    height: clamp(400px, 48vh, 620px);
}

.work-order-detail-amap--row,
.work-order-detail-amap-inner--row {
    height: clamp(200px, 24vh, 300px);
}

.work-order-imgs-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.work-order-img-thumb {
    width: 140px;
    height: 140px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    cursor: pointer;
}

.work-order-img-thumb ::v-deep .el-image__inner {
    object-fit: contain;
}

::v-deep .work-order-imgs-dialog .el-dialog__body {
    padding-top: 12px;
}

::v-deep .work-order-detail-tabs.el-tabs .el-tabs__header {
    margin-bottom: 4px;
}

::v-deep .work-order-detail-dialog .el-dialog__body {
    padding-top: 8px;
    padding-bottom: 4px;
    overflow-y: hidden;
}
</style>

<style lang="scss">
/* 工单详情地图：Marker 挂载在地图容器内，scoped 无法生效 */
/* 圆点尺寸 8×8，配合 marker :offset="[-4,-4]" 让圆心对齐 position */
.work-order-detail-traj-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    box-sizing: border-box;
    background: #f5222d;
    border: 1px solid #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    pointer-events: auto;
}

.work-order-detail-traj-dot--active {
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.85);
}

/* 起点/终点：26×26，配合 marker :offset="[-13,-13]" 让中心对齐 position */
.work-order-detail-traj-pin {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 2px solid #fff;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    pointer-events: auto;
    user-select: none;
}

.work-order-detail-traj-pin--start {
    background: #52c41a;
}

.work-order-detail-traj-pin--end {
    background: #f5222d;
}

/* 与订单轨迹悬停提示接近；内容由 InfoWindow 注入，故不用 scoped */
.wo-order-traj-tip {
    font-size: 12px;
    line-height: 1.35;
    color: #333;
    padding: 4px 8px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    white-space: normal;
    max-width: 260px;
}
</style>
